<label *ngIf="title">{{ title }}</label>
<div class="btn-toolbar" role="toolbar">
    <button
        *ngFor="let btn of buttons || []"
        type="button"
        [disabled]="isDisabled(btn)"
        class="btn btn-default"
        [ngClass]="btn.class"
        (click)="handleBtnClick(btn)"
        [title]="btn.tooltip || ''"
        [style.order]="btn.flexOrder || 0"
    >
        <span *ngIf="btn.glyphicon" class="glyphicon" [ngClass]="btn.glyphicon" aria-hidden="true"></span>
        {{ btn.caption }}
    </button>
</div>
